
import { post, get } from '../../../../services/request';


// Get Provider Profile by ID
export const getRadProfileById = (radId) => {
    return get(`Radiologist/GetRadiologistDetailsByID?RadiologistID=${radId}&todayDate=2025-11-05&_=1762323783538`);
};

// Add Provider Schedule
export const addRadSchedule = () => {
    return get('ShiftInputDetails/GetRadiologistShiftInputDetailsByID?ShiftInputDetailID=0');
};

// Save Rad Schedule
export const saveRadSchedule = (payload) => {
    return post('ShiftInputDetails/SaveRadiologistShiftInputDetails', payload);
};

// Get Radiologist Tasks by Date
export const getRadiologistTasksByDate = ({ RadiologistID, ShiftDate }) => {
    const radId = encodeURIComponent(RadiologistID);
    const date = encodeURIComponent(ShiftDate);
    return get(`Radiologist/GetRadiologistTasksByDate?RadiologistID=${radId}&ShiftDate=${date}`);
};

// Get Rad Profile Associated Site Matrics
export const getRadProfileAssociatedSiteMatrics = (Payload) => {
    return post(`Radiologist/GetSiteMatrixDetails`, Payload);
};

// Get Rad Site Matrix Dropdown
export const getRadSiteMatrixDropdown = (Payload) => {
    return post(`Radiologist/GetRadSiteMatrixDropdown`, Payload);
};

// Get Site Metrics Child Table
export const getSiteMetricsChildTable = (Payload) => {
    return post(`Radiologist/GetSiteMatrixChildTables`, Payload);
};


//GetRadiologist YTD By ID
export const getRadiologistYTDByID = (radId) => {
    return post(`Radiologist/GetRadiologistYTDByID`, { RadiologistId: radId });
};
////dropdown bindings in the Update Schedule Information(Start)
// Fetch Provider Dropdown Tasks
export const getRadDropdownTasks = (ShiftInputDetailID) => {
    return get(`ShiftInputDetails/GetRadiologistShiftInputDetailsByID?ShiftInputDetailID=${ShiftInputDetailID}`);
};

// Delete Shift Input Details
export const deleteShiftInputDetails = (payload) => {
    return post('ShiftInputDetails/DeleteShiftInputDetails', payload);
};

// Get schedules by date range
export const getSchedulesByDateRange = (payload) => {
    return post('Radiologist/GetSchedulesByDateRange', payload);
};


// Provider Profile Provider Metrics -chart
export const RadProfileChartDetails = (payload) => {
    return post('Radiologist/GetRadiologistProfileChartDetails', payload);
};

// Provider Metrics Dropdown
export const getRadProviderMetricsDropdown = () => {
    return post('Radiologist/GetRadiologistProviderMetricsDropdown', {});
};

// Provider Metrics Chart Details (with filters)
export const getRadProviderMetricsChartDetails = (payload) => {
    return post('Radiologist/GetRadiologistProviderMetricsChartDetails', payload);
};

// Rad Profile Download Image
export const downloadRadProfileImage = (payload) => {
    return post('Radiologist/DownloadRadProfileImage', payload);
};

//Rad Profile Delete Photo

export const deleteRadProfilePhoto = (payload) => {
    return post('Radiologist/DeleteRadProfileImage', payload);
}

// Rad Profile Save Image

export const saveRadProfileImage = (formData) => {
    return post('Radiologist/RadiologistProfileImageUpload', formData, {

    });
};

// Rad Site Assignment Notes
export const getRadSiteAssignmentNotes = (payload) => {
    return get(`RadSiteAssignmentNotes/GetRadSiteAssignmentNotesByID?radiologistSiteAssignmentID=${payload.radiologistSiteAssignmentId}`);
};

export const getLicenseAndRadSiteAssignmentNotes = (payload) => {
    return get(`RadSiteAssignmentNotes/GetLicenseAndRadSiteAssignmentNotesByProviderId?radiologistID=${payload.providerId}`);
};

export const addRadSiteAssignmentNote = (payload) => {
    return post('RadSiteAssignmentNotes/AddRadSiteAssignmentNote', payload);
};